import React, { useRef } from 'react';
import { NavLink } from 'react-router-dom';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import { GiFairyWings } from 'react-icons/gi'; 
import './HomeSlider.css';

// Importing images
import event from '../../../assets/home/event.jpg';
import member from '../../../assets/home/member.png';
import pratibha from '../../../assets/home/pratibha.jpg';
import news from '../../../assets/home/world.gif';

const carouselData = [
  {
    id: 1,
    title: "EVENTS",
    link: "/events",
    img: event 
  },
  {
    id: 2,
    title: "MEMBER",
    link: "/about/members",
    img: member 
  },
  {
    id: 3,
    title: "PRATIBHA KHOJ",
    link: "/pratibha-khoj/pariksha",
    img: pratibha 
  },
  {
    id: 4,
    title: "NEWS",
    link: "/news",
    img: news 
  }
];

// Duplicating the data for continuous sliding on larger screens
const extendedData = [
  ...carouselData, 
  ...carouselData.map(item => ({ ...item, id: item.id + '_copy' }))
];

function HomeSlider() {
  const sliderRef = useRef(null);

  // Dynamic scroll logic that adapts to actual card sizes and gaps
  const scroll = (direction) => {
    if (sliderRef.current) {
      const card = sliderRef.current.querySelector('.home-carousel-component-card');
      if (card) {
        const cardWidth = card.offsetWidth;
        // Retrieves the computed gap value from CSS
        const computedStyle = window.getComputedStyle(sliderRef.current);
        const gap = parseFloat(computedStyle.gap) || 0;
        
        const scrollAmount = cardWidth + gap;
        
        sliderRef.current.scrollBy({
          left: direction === 'left' ? -scrollAmount : scrollAmount,
          behavior: 'smooth'
        });
      }
    }
  };

  return (
    <section className="home-carousel-component-section">
      <div className="home-carousel-component-container">
        
        {/* --- HEADER & DIVIDER --- */}
        <div className="home-carousel-component-header">
          <h2 className="home-carousel-component-title">RAJPUT SHIKSHA KOSH</h2>
          <div className="home-carousel-component-divider">
            <span className="home-carousel-component-line"></span>
            <GiFairyWings className="home-carousel-component-icon" />
            <span className="home-carousel-component-line"></span>
          </div>
        </div>

        {/* --- SLIDER AREA --- */}
        <div className="home-carousel-component-slider-wrapper">
          
          <button 
            className="home-carousel-component-arrow left" 
            onClick={() => scroll('left')}
            aria-label="Previous"
          >
            <FaChevronLeft />
          </button>

          <div className="home-carousel-component-track" ref={sliderRef}>
            {extendedData.map((item) => (
              <div className="home-carousel-component-card" key={item.id}>
                <div className="home-carousel-component-img-wrapper">
                  <img src={item.img} alt={item.title} className="home-carousel-component-img" />
                </div>
                <h3 className="home-carousel-component-card-title">{item.title}</h3>
                <NavLink to={item.link} className="home-carousel-component-card-link">
                  View More
                </NavLink>
              </div>
            ))}
          </div>

          <button 
            className="home-carousel-component-arrow right" 
            onClick={() => scroll('right')}
            aria-label="Next"
          >
            <FaChevronRight />
          </button>

        </div>

      </div>
    </section>
  );
}

export default HomeSlider;